export default __webpack_public_path__ + "static/media/Fleshflayer Gloves.95b3c78f.jpg";